// extracted by mini-css-extract-plugin
module.exports = {"leftArrow":"AuctionNavigation_leftArrow__1NOSB","rightArrow":"AuctionNavigation_rightArrow__33rdI"};